import script from "./ClientFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientFooter.vue?vue&type=script&setup=true&lang=js"

import "./ClientFooter.vue?vue&type=style&index=0&id=5e566ae2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e566ae2"]])

export default __exports__